import "./ImageSprite.scss"
import { FC } from 'react'

interface ImageSpriteProps {
    iconSprite: string,
}

const ImageSprite: FC<ImageSpriteProps> = (props) => {
    return (
        <svg>
            <use xmlns="http://www.w3.org/2000/svg" xlinkHref={props.iconSprite} />
        </svg>
    )
}

export default ImageSprite
